export default {"src":"/_next/static/media/MenuYugi.4ec0ab09.svg","height":224,"width":64,"blurWidth":0,"blurHeight":0};